import {
  PASSWORD_STRENGTH_SUCCESS,
  PASSWORD_STRENGTH_FAILURE,
  PASSWORD_STRENGTH_CLEAR,
  RESET_STORED_DATA
} from '../constants'

const initialState = {
  passwordStrength: {
    title: '',
    message: '',
    fgColor: '',
    bgColor: '',
    filledBarPercent: 0,
    blocked: true
  },
  passwordStrengthError: '',
  displayPasswordStrength: false,
  hydrated: false
}

const hexToColor = new Map([
  ['#e32b1e', 'red'],
  ['#fed921', 'yellow'],
  ['#6abf4f', 'green'],
  ['#e9ebed', 'grey']
])

export default function password(state = initialState, action) {
  if (typeof window !== 'undefined' && !state.hydrated) {
    state = { ...initialState, ...state, hydrated: true }
  }

  switch (action.type) {
    case RESET_STORED_DATA: {
      return { ...initialState }
    }
    case PASSWORD_STRENGTH_SUCCESS: {
      const { title, message, fg_color: fgColorHex, filled_bar_percent: filledBarPercent, blocked } = action.data

      const fgColor = hexToColor.get(fgColorHex) || fgColorHex

      return {
        ...state,
        displayPasswordStrength: true,
        passwordStrength: {
          title,
          message,
          fgColor,
          filledBarPercent,
          blocked
        }
      }
    }

    case PASSWORD_STRENGTH_FAILURE: {
      return {
        ...state,
        displayPasswordStrength: false
      }
    }

    case PASSWORD_STRENGTH_CLEAR: {
      return initialState
    }

    default:
      return state
  }
}

export const selectPasswordStrength = state => state.password.passwordStrength
export const selectDisplayPasswordStrength = state => state.password.displayPasswordStrength
